import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'network-api-google-yahoo',
  templateUrl: './api-google-yahoo.component.html',
  styleUrls: ['./api-google-yahoo.component.scss']
})
export class ApiGoogleYahooComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
